/** @jsxImportSource @emotion/react */

import { css } from "@emotion/core";
import { useHistory } from "react-router-dom";
import zitelLogo from "../../assets/images/zitel-logo.svg";
import Grid from "ui-modules/components/Layout/Grid";
import GridCell from "ui-modules/components/Layout/Grid/GridCell";
import Paper from "../../components/Paper";
import Text from "ui-modules/components/DataDisplay/Text";
import Button from "ui-modules/components/Form/Button";
import Img from "ui-modules/components/Image/Img";
import Image from "../../assets/images/Payment-No-02.svg";
import Icon from "../../components/Icon";

const FailedPayment = () => {
  const history = useHistory();
  const queryParameters = new URLSearchParams(window.location.search);
  const errorMessage = queryParameters.get("errorMessage");

  const styles = css`
    .failed-container {
      color: inherit;
      text-align: center;
      min-height: 95vh;
    }
    Img {
      width: 100px;
      margin-top: 20px;
    }
    .failed-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 70vh;
    }
    .error-message {
      color: #faa61a;
      margin-bottom: 25px;
      display: inherit;
      font-size: 20px;
    }
    .title {
      font-size: 16px;
      margin-bottom: 30px;
      font-weight: bold;
    }
    a {
      color: white;
      font-size: 20px;
    }
    .home-button {
      margin-top: 60px;
      width: 350px;
    }
  `;

  return (
    <Grid css={styles}>
      <GridCell phone={4} tablet={8} desktop={12}>
        <Paper className="paper--content failed-container">
          <Img src={zitelLogo} alt="zitel-logo" />
          <div className="failed-wrapper">
            <div>
              <img src={Image} alt="zitel" style={{ width: "72%" }} />
              <strong className="error-message">{errorMessage}</strong>
              <Text className="title">در صورت کسر شدن وجه از حساب شما، طی ساعات آتی به حساب شما باز خواهدگشت.</Text>
              <Text>
                <a href="tel:1739">۱۷۳۹</a>
                <Icon name={"phone-ringing"} className={"medium"} />
              </Text>
              <Button className="home-button" onClick={() => history.push(`/`)}>
                سامانه مشترکین زی‌تل
              </Button>
            </div>
          </div>
        </Paper>
      </GridCell>
    </Grid>
  );
};

export default FailedPayment;
